import { Component, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
  selector: 'app-viewport-snackbar',
  templateUrl: './main-toolbar-snackbar.component.html',
  styleUrls: ['./main-toolbar-snackbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainToolbarSnackbarComponent {
  constructor(
    public snackBarRef: MatSnackBarRef<MainToolbarSnackbarComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public message: string,
  ) {}
}
